import { OptionsActionTypes } from './types';

interface ISetDisplayAddButton {
  type: OptionsActionTypes.SET_DISPLAY_ADD_BUTTON;
  payload: {
    display: boolean;
  }
}

export const setDisplayAddButton = (display: boolean): ISetDisplayAddButton => ({
  type: OptionsActionTypes.SET_DISPLAY_ADD_BUTTON,
  payload: {
    display
  }
});

interface ISetDisplaySearch {
  type: OptionsActionTypes.SET_DISPLAY_SEARCH;
  payload: {
    display: boolean;
  }
}

export const setDisplaySearch = (display: boolean): ISetDisplaySearch => ({
  type: OptionsActionTypes.SET_DISPLAY_SEARCH,
  payload: {
    display
  }
});

interface ISetSearchTerm {
  type: OptionsActionTypes.SET_SEARCH_TERM;
  payload: {
    term: string
  }
}

export const setSearchTerm = (term: string): ISetSearchTerm => ({
  type: OptionsActionTypes.SET_SEARCH_TERM,
  payload: {
    term
  }
});

interface ISetDisplayMenu {
  type: OptionsActionTypes.SET_DISPLAY_MENU;
  payload: {
    display: boolean
  }
}

export const setDisplayMenu = (display: boolean): ISetDisplayMenu => ({
  type: OptionsActionTypes.SET_DISPLAY_MENU,
  payload: {
    display
  }
});

export type OptionAction =
  | ISetDisplayAddButton
  | ISetDisplaySearch
  | ISetSearchTerm
  | ISetDisplayMenu;
